// Vendor libraries
import { createReducer, on } from '@ngrx/store';
import { setModuleConfigMap } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/module-config-map/module-config-map.action';
export const module_config_map = createReducer({}, on(setModuleConfigMap, (state, { moduleConfigMap }) => {
    return moduleConfigMap;
}));
